'use strict';

import analytics from '../utils/analytics';
import cookie from '../storage/cookie';
import foundationLoader from '../utils/foundation-loader';
import logger from '../utils/logger';
import vendorConsents from '../utils/vendor-consents';
import localStorageUtils from '../utils/localStorageUtils'; // TODO: Rename this file to hyphenated
import user from '../profile/user';

const classNames = {
	newsletterSignup: 'newsletter-signup',
	newsletterSignupSubmit: 'newsletter-signup__submit',
	completeButton: 'complete-button',
	errorLabel: 'error-label',
	input: 'input',
	button: 'button',
	promptLabel: 'prompt-label',
	successLabel: 'success-label',
};

const modifierNames = {
	submitting: 'submitting'
};

const trackingCategory = 'NTG newsletter';

// TODO Make casing consistent across all instances of CONSENT_STORAGE_KEY (and consider moving to reusable location)
const CONSENT_STORAGE_KEY = 'consentData';  // Match the key from consent manager

function initVisibility() {
	let newsletterSignupCookie = cookie.getCookie(cookie.names.newsletterSignup);

	if (!newsletterSignupCookie) {
		newsletterSignupCookie = {
			pageViewCount: 1,
			interacted: false
		};
	} else {
		newsletterSignupCookie.pageViewCount++;
	}

	cookie.setCookie(cookie.names.newsletterSignup, newsletterSignupCookie);

	const pageViewThreshold = $('#newsletterSignup').data('page-view-threshold');

	if (newsletterSignupCookie.pageViewCount >= pageViewThreshold && !newsletterSignupCookie.interacted) {
		$.findByBem(classNames.newsletterSignup).show();
		analytics.trackEvent(trackingCategory, 'Load', window.location.href);
	}
}

function initCloseButton() {
	$.findByBem(classNames.newsletterSignup, 'close').on('click', function () {
		$.findByBem(classNames.newsletterSignup).hide();
		setCookieInteracted();
	});

	$.findByBem(classNames.newsletterSignup, classNames.completeButton).on('click', function () {
		$.findByBem(classNames.newsletterSignup).hide();
	});
}

function send(target) {
	const $formElements = $(target).find('input');

	analytics.trackEvent(trackingCategory, 'newsletter signup', 'success');

	$.findByBem(classNames.newsletterSignupSubmit, classNames.errorLabel).hide();
	$.findByBem(classNames.newsletterSignupSubmit, classNames.input).attr('disabled', true);
	$.findByBem(classNames.newsletterSignupSubmit, classNames.button)
		.attr('disabled', true)
		.html('Submitting&hellip;')
		.addBemClass(classNames.newsletterSignupSubmit, classNames.button, modifierNames.submitting);

	const userEmail = $formElements.filter('#emailInput').val()
	let template = '';
	let reason = user.getValuationPurpose();

	if (reason === null) {
		reason = document.querySelector('input[name="valuationPurpose"]:checked')?.value;		
	}

	if (window.bauerDataLayer[0]?.page) {
		template = window.bauerDataLayer[0].page.templateName;
	}
	else if (window.dpfData) {
		template = window.dfpData.templateName;
	}

	$.ajax({
		method: 'POST',
		url: `/api/newsletter-signup/subscribe`,
		data: { Email: userEmail, Template: template, Reason: reason },
		cache: false,
		success: function (resultData) {
			$.findByBem(classNames.newsletterSignupSubmit, classNames.button).hide();
			$.findByBem(classNames.newsletterSignupSubmit, classNames.promptLabel).hide();
			$.findByBem(classNames.newsletterSignup, classNames.completeButton).css('display', 'block');
			$.findByBem(classNames.newsletterSignupSubmit, classNames.successLabel).show();
			$.findByBem(classNames.newsletterSignupSubmit, classNames.input).attr('disabled', 'true');
			setCookieInteracted(userEmail, resultData);
		},
		error: function (xhr, status, err) {
			$.findByBem(classNames.newsletterSignupSubmit, classNames.errorLabel).css('display', 'block').insertAfter(err);
			$.findByBem(classNames.newsletterSignupSubmit, classNames.input).attr('disabled', false);
			$.findByBem(classNames.newsletterSignupSubmit, classNames.button)
				.attr('disabled', false)
				.html('Submit')
				.removeBemClass(classNames.newsletterSignupSubmit, classNames.button, modifierNames.submitting);
		}
	});
}

function setCookieInteracted(userEmail, newsletterSubscribeResult) {
	const  newsletterSignupCookie = cookie.getCookie(cookie.names.newsletterSignup);

	if (newsletterSignupCookie) {
		newsletterSignupCookie.interacted = true;

		cookie.setCookie(cookie.names.newsletterSignup, newsletterSignupCookie);

		if (window.permutive && newsletterSubscribeResult) {
			window.permutive.identify([
				{
					id: newsletterSubscribeResult.userSaltedEmailHash,
					tag: 'bauer_id',
					priority: 0
				},
				{
					id: newsletterSubscribeResult.userEmailHash,
					tag: 'email_sha256',
					priority: 1
				}
			]);

			setPermutiveCookie(newsletterSubscribeResult);
		}
	}
}

function setPermutiveCookie(newsletterSubscribeResult) {
	let permutiveUserEmailHashCookie = cookie.getCookie(cookie.names.permutiveUserEmailHash);

	if (!permutiveUserEmailHashCookie)
	{
		permutiveUserEmailHashCookie = {
			permutiveUserEmailHashData: {
				userEmailHash: newsletterSubscribeResult.userEmailHash,
				userSaltedEmailHash: newsletterSubscribeResult.userSaltedEmailHash
			},
			userKnown: true
		};

		cookie.setCookie(cookie.names.permutiveUserEmailHash, permutiveUserEmailHashCookie);
	}
}

function onConsentGranted() {
	foundationLoader.addPlugins(foundationLoader.PLUGINS.ABIDE);

	initVisibility();
	initCloseButton();

	$(window).on('load', function () {
		$(document).on('formvalid.zf.abide', function (e, target) {
			send(target);
		}).on('submit', function (e) {
			e.preventDefault();
		});
	});
}

function onConsentRefused() {
	cookie.deleteCookie(cookie.names.newsletterSignup);
	logger.info('Did not initialise newsletter on completed user action: Insufficient consent');
}

export default {
	init: function () {
		const storedConsent = localStorageUtils.getItem(CONSENT_STORAGE_KEY);
		if (!storedConsent) {
			logger.warning('Failed to initialise newsletter: No consent data');
			return;
		}

		const hasBauerConsent = storedConsent.consentedVendors.includes(vendorConsents.vendorIds.bauerMediaGroup);
		if (hasBauerConsent) {
			onConsentGranted();
		} else {
			onConsentRefused();
		}
	}
}